module.exports = __webpack_public_path__ + "img/5.c512e8a9.png";